import { putApiToServer } from "../callApi";

export async function accountFreezeApi(authtoken, salesmanId, city = "") {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      city: city,
    });

    let endUrl = `v1/auth/salesman-unfreeze/${salesmanId}`;

    let responseData = await putApiToServer(body, header, "PUT", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
